"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiListSearch = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var image_button_1 = require("../../components/button/image.button");
var icon_1 = require("../../components/icon");
var icons_1 = require("../../components/icon/icons");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var multi_list_search_style_1 = require("./multi.list.search.style");
(0, theme_1.addStyles)(multi_list_search_style_1.Style);
var MultiListSearch = /** @class */ (function (_super) {
    tslib_1.__extends(MultiListSearch, _super);
    function MultiListSearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MultiListSearch.prototype, "nodes", {
        get: function () {
            var _this = this;
            //the filterbar is an IKE Analyze only feature
            if (!services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
                services_1.Services.MultiListSearch.filterState.clear();
                services_1.Services.MultiListSearch.inputfilterState.clear();
                return null;
            }
            var cancelButton = image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
                className: multi_list_search_style_1.CSS.clear,
                onclick: function () { return services_1.Services.MultiListSearch.reset(); }
            });
            var icon = services_1.Services.MultiListSearch.filtering ?
                spinner_1.Spinner.view(multi_list_search_style_1.CSS.icon) :
                icon_1.Icon.view(icons_1.MaterialIcon.SEARCH, { className: multi_list_search_style_1.CSS.icon });
            return (0, mithril_1.m)('div', { className: multi_list_search_style_1.CSS.container }, [
                icon,
                (0, mithril_1.m)('input', {
                    className: multi_list_search_style_1.CSS.input,
                    type: 'text',
                    placeholder: (0, index_1.Translate)(index_1.T.FILTER),
                    value: services_1.Services.MultiListSearch.inputfilterState.filter,
                    oninput: function (e) { return _this.onChange(e); }
                }),
                services_1.Services.MultiListSearch.inputfilterState.hasFilter() ? cancelButton : null
            ]);
        },
        enumerable: false,
        configurable: true
    });
    MultiListSearch.prototype.onChange = function (e) {
        services_1.Services.MultiListSearch.inputfilterState.setFilter(e.target.value);
    };
    return MultiListSearch;
}(mithril_component_1.IMithrilComponent));
exports.MultiListSearch = MultiListSearch;
//# sourceMappingURL=multi.list.search.js.map